import config from "site-config";
import fetch from "lib/fetch";
import { formatMessage } from "lib/globalize-util";

let loading = false;

export const initZendesk = async ({ me, locale, isRetailer, callback }) => {
    if (!loading) {
        loading = true;
        let isTradeshow = false;

        // If brand user, check to see if they are only in tradeshow subscription brands
        if (me.account_type === "brand") {
            try {
                const brands = await fetch("/brands?active=true").then((res) => res.json());
                isTradeshow = brands.every((brand) => brand?.settings?.subscription_type === "tradeshow");
            } catch {
                // ignore
            }
        }

        // initial settings
        window.zESettings = {
            webWidget: {
                position: { horizontal: "right", vertical: "bottom" },
                color: {
                    theme: "#5199DC",
                    launcher: "#5199DC",
                    launcherText: "#fff",
                    // button: '#8A0648',
                    // resultLists: '#691840',
                    // header: '#60a2e1',
                    // articleLinks: '#FF4500'
                },
                // talk: {
                //     nickname: "Sales Support",
                // },
                authenticate: {
                    jwtFn: (callback) => {
                        fetch("/login/zendesk/jwt_web_widget")
                            .then((res) => res.text())
                            .then((jwt) => {
                                callback(jwt);
                            })
                            // eslint-disable-next-line
                            .catch((e) => console.error(e));
                    },
                    chat: {
                        jwtFn: (callback) => {
                            fetch("/login/zendesk/jwt")
                                .then((res) => res.text())
                                .then((jwt) => {
                                    callback(jwt);
                                })
                                // eslint-disable-next-line
                                .catch((e) => console.error(e));
                        },
                    },
                },
            },
        };

        if (isTradeshow) {
            window.zESettings.webWidget = {
                ...window.zESettings.webWidget,
                ...{
                    helpCenter: { title: { "*": formatMessage("Tradeshow Support") } },
                    contactOptions: {
                        enabled: true,
                        contactButton: { "*": formatMessage("Contact us") },
                    },
                    chat: { departments: { enabled: ["tradeshow"], select: "tradeshow" } },
                    talk: { suppress: true },
                },
            };
        }

        const zendeskId = isRetailer ? config.ZENDESK_RETAILER : config.ZENDESK;

        if (zendeskId) {
            const y = document.createElement("script");
            y.async = true;
            y.id = "ze-snippet";
            y.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskId}`;
            const z = document.getElementsByTagName("script")[0];
            z.parentNode.insertBefore(y, z);

            y.addEventListener("load", () => {
                window.zE("webWidget", "hide");
                window.zE("webWidget", "helpCenter:setSuggestions", { url: true });
                window.zE("webWidget:on", "close", () => {
                    window.zE("webWidget", "hide");
                });

                // Commenting below line. Looks like there is internal API change that resets auth key when `identify` is explicitly called AFTER authentication that was done during Zendesk init
                // window.zE("webWidget", "identify", { name: me.name, email: me.email });

                if (locale) {
                    window.zE("webWidget", "setLocale", locale);
                }

                if (callback) {
                    callback();
                }
            });
        }
    }
};
